// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2oUMB","header":"PatientQuestionnaire_header__1iloG","info":"PatientQuestionnaire_info__jnP-d"};